import React from 'react';
import './Button.scss';

function Button({ children, icon: Icon, ...props }) {
  return (
    <button className="button-o-my" {...props}>
      {children}
      {Icon && <Icon className="button-icon" />}
    </button>
  );
}

export default Button;